import React from 'react';
import { PropTypes } from 'prop-types';
import FlatButton from './FlatButton';

const renderIcon = item => {
  if (item.skipped) {
    return <i className="fas fa-exclamation-triangle skipped" title="Skipped" />;
  }

  if (item.saved) {
    return <i className="zmdi zmdi-check saved" title="Saved" />;
  }

  return <i className="zmdi zmdi-close unsaved" title="Not Saved" />;
};

const Review = props => {
  const { edit, list, submit } = props;

  return (
    <div className="scan-review">
      <div className="review-list">
        <div className="review-row head">
          <div className="review-col">Bin</div>
          <div className="review-col">Part</div>
          <div className="review-col center">Qty</div>
          <div className="review-col center">Saved</div>
        </div>

        {list.map((item, index) => {
          if (!item.done) {
            return null;
          }

          return (
            <div className="review-row data" key={`${item.bin}${item.part}${index}`}>
              <div className="review-col" onClick={() => edit(index, 0)}>
                {item.bin}
              </div>
              <div className="review-col" onClick={() => edit(index, 1)}>
                {item.part}
              </div>
              <div className="review-col center" onClick={() => edit(index, 2)}>
                {item.qty}
              </div>
              <div className="review-index center">
                {renderIcon(item)}
              </div>
            </div>
          );
        })}
      </div>
      <FlatButton className="add-more" onClick={() => edit('last')}>
        Add More
      </FlatButton>
      <FlatButton className="primary" onClick={() => submit()}>
        Save All
      </FlatButton>
    </div>
  );
};

Review.propTypes = {
  edit: PropTypes.func,
  list: PropTypes.array,
  submit: PropTypes.func,
};

export default Review;
